import {RouteDefinition} from '../../../routes';
import {CameraBrandListScreen} from './CameraBrandListScreen';
import {CameraBrandEditScreen} from './CameraBrandEditScreen';

export const CameraBrandSettingsRoutes: RouteDefinition[] = [
    {
        name: 'Kamera Marka OLUŞTUR',
        routerLink: '/developer/camera-brand/edit',
        component: CameraBrandEditScreen,
    },
    {
        name: 'Kamera Marka DETAY',
        routerLink: '/developer/camera-brand/edit/:id',
        component: CameraBrandEditScreen,
    },
    {
        name: 'Kamera Marka AYARLARI',
        routerLink: '/developer/camera-brand',
        component: CameraBrandListScreen,
    },
];
